module.exports = __webpack_public_path__ + "step4.86503ed0cf9443573eeedf0d79ef8147.png";